var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M187.914 118.6h-9.032a2.4 2.4 0 0 0-1.756.779 2.762 2.762 0 0 0-.728 1.882v6.645a2.762 2.762 0 0 0 .728 1.882 2.4 2.4 0 0 0 1.756.779h9.032a2.4 2.4 0 0 0 1.756-.779 2.762 2.762 0 0 0 .728-1.882v-6.645a2.762 2.762 0 0 0-.728-1.882 2.4 2.4 0 0 0-1.756-.779zm-9.032 1.452h9.032a1.092 1.092 0 0 1 .8.354 1.255 1.255 0 0 1 .331.855v-.413l-5.645 3.439-5.645-3.439v.413a1.255 1.255 0 0 1 .331-.855 1.092 1.092 0 0 1 .8-.354zm9.032 9.064h-9.032a1.092 1.092 0 0 1-.8-.354 1.255 1.255 0 0 1-.331-.855v-5.388l5.146 3.146a.87.87 0 0 0 1 0l5.148-3.146v5.388a1.255 1.255 0 0 1-.331.855 1.092 1.092 0 0 1-.8.354z",
    transform: "translate(-176.398 -117.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.532cfdccacea200480d12b436d48af79.svg";
export { ForwardRef as ReactComponent };